var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{class:_vm.getClass(),attrs:{"src":_vm.getSrc()}})
}
var staticRenderFns = []

export { render, staticRenderFns }